import React, {Component} from 'react'

import Screen from '../ui/Screen'

import ControlPanel from "./ShowsScreen/ControlPanel"
import SearchPanel from "./ShowsScreen/SearchPanel"
import ShowsList from "./ShowsScreen/ShowsList"
import CreateShowDialog from "./ShowsScreen/CreateShowDialog"
import EditShowDialog from "./ShowsScreen/EditShowDialog.js"
import DeleteShowDialog from "./ShowsScreen/DeleteShowDialog"
import ShowItemsScreen from "./ShowsScreen/ShowItemsScreen"
import SaveShowDialog from './ShowsScreen/SaveShowDialog.js'

import ErrorMessageDialog from "./../ui/ErrorMessageDialog"

import Cookie from "../Cookie"
import {config} from "../config"
import api from "./../api.js"

import CompleteShowDialog from "./ShowsScreen/ShowItemsScreen/CompleteShowDialog"

/**
 * onCreatePurchase(attachments)
 * onAttachPurchase(attachments)
 */

class ShowsScreen extends Component {

	constructor(props) {
		super(props)

		this.state = {
			shows: [],
			selected: undefined,
			filter: this.filters[1],
			orderByDate: this.orderByDateConditions[0],
			dialog: undefined,
			screen: undefined,
			searchString: "",
			search: "",
		}

	}	

	orderByDateConditions = [
		{
			title: "Без сортировки",
			value: "none",
		},
		{
			title: "Сначала новые",
			value: "desc",
		},
		{
			title: "Сначала старые",
			value: "asc",
		},
	]

	filters = [
		{
			title: "Показать все",
			value: "all"
		},
		{
			title: "Активные шоу",
			value: "active"
		},
		{
			title: "Завершенные шоу",
			value: "completed"
		},
	]

	updateShow = (show) => {
		return new Promise((resolve, reject) => {
			let xhr = new XMLHttpRequest()
			xhr.open("PUT", config.restApiHost + `/show/${show.id}?sid=${Cookie.get("sid")}`)
			xhr.onreadystatechange = ()=>{
				if (xhr.readyState === 4) {
					if (xhr.status === 200) {
						resolve()
					} else {
						reject("Не удалось обновить шоу.")
					}
				}
			}
			xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8")
			xhr.send(JSON.stringify(show))
		})
	}

	deleteShow(show) {
		return new Promise((resolve, reject) => {
			let xhr = new XMLHttpRequest()
			xhr.open("DELETE", config.restApiHost + `/show/${show.id}?sid=${Cookie.get("sid")}`, true)
			xhr.onreadystatechange = ()=>{
				if (xhr.readyState === 4) {
					if (xhr.status === 200) {
						let json = JSON.parse(xhr.responseText)
						resolve(json)
					} else {
						reject("Не удалось удалить шоу.")
					}
				}
			}
			xhr.send()
		})
	}

	findNewSelected(selected, shows) {
		if (selected) {
			for(let show of shows) {
				if (show.id === selected.id) {
					return show
				}
			}
		}
	}

	update = async () => {
		try {
			let { shows } = await api.shows.list(
				this.state.filter.value,
				this.state.searchString,
				this.state.orderByDate.value,
			)
			for (let n in shows) {
				if (shows[n].box_id > 0) {
					let { box } = await api.boxes.get(shows[n].box_id)	
					shows[n].box = box
				} else {
					shows[n].box ={id: 0, code: ""}
				}
			}
			this.setState({
				selected: this.state.selected ? shows.find(show => show.id === this.state.selected.id) : undefined,
				shows: shows,
			})
		}
		catch(e) {
			this.handle_error(e)
		}
	}

	componentDidMount() {
		this.update().catch(this.handle_error)
	}

	handle_error = (error) => {
        let message = error instanceof String ? error : error.message
		this.setState({
			dialog: <ErrorMessageDialog 
				message = {message}
				onClose = {async () => {
					try {
						await this.update()
						this.setState({dialog: undefined})
					}
					catch(e) {
						this.handle_error(e)
					}
				}}
			/>
		})
	}    

	handleCreateShow = () => {
		this.setState({
			dialog: <CreateShowDialog
				onCreateShow = {async show => {
					try {
						await api.shows.create(show)
						await this.update()
						this.setState({
							dialog: undefined
						})
					}
					catch(e) {
						this.handle_error(e)
					}
				}}
				onCancel = {() => {
					this.setState({
						dialog: undefined
					})
				}}
			/>
		})
	}

	handleOpenShow = async (show) => {
		api.shows.attachments.list(show.id)
			.then(response => {
				show.items = response.attachments

				this.setState({
					screen: <ShowItemsScreen
						show = {show}
						onCreatePurchase = {purchase => {
							this.setState({screen: undefined})
							if (typeof this.props.onCreatePurchase === "function") {
								this.props.onCreatePurchase(purchase)
							}
						}}
						onAttachPurchase = {purchase => {
							this.setState({screen: undefined})
							if (typeof this.props.onAttachPurchase === "function") {
								this.props.onAttachPurchase(purchase)
							}
						}}
						onClose = {() => {
							this.update().then(() => {
								this.setState({screen: undefined})
							}, this.handle_error)
						}}
					/>
				})
				
			})
			.catch(this.handle_error)
	}

	handleEditShow = async (show) => {
		this.setState({
			dialog: <EditShowDialog
				show = {show}
				onUpdateShow = {show => {
					this.updateShow(show).then(show => {
						this.update().then(() => {
							this.setState({
								dialog: undefined
							})
						}, this.handle_error)
					}, this.handle_error)
				}}
				onCancel = {() => {
					this.setState({
						dialog: undefined
					})
				}}
			/>
		})
	}

	handleDeleteShow = (show) => {
		this.setState({
			dialog: <DeleteShowDialog
				show = {show}
				onDeleteShow = {show => {
					this.deleteShow(show).then(() => {
						this.update().then(() =>{
							this.setState({
								dialog: undefined
							})
						}, this.handle_error)
					}, this.handle_error)
				}}
				onCancel = {() => {
					this.setState({
						dialog: undefined
					})
				}}
			/>
		})
	}

	handleSelectFilter = (filter) => {
		this.setState({
			filter: filter
		}, this.update)
	}

	handleSelectOrderByDate = (order) => {
		this.setState({
			orderByDate: order
		}, this.update)
	}	

	handleSearch = async (searchString) => {
		this.setState({ searchString: searchString })
		await this.update()
	}

	handleClickShow = (show) => {
		if (this.state.selected) {
			if (this.state.selected.id === show.id) {
				this.handleOpenShow(show)
				return
			}
		}
		this.setState({
			selected:  show
		})
	}

	handleCompleteShow = (show) => {

		function updateShowComment(show, comment) {
			return new Promise((resolve, reject) => {
				let xhr = new XMLHttpRequest()
				xhr.open("PUT", config.restApiHost + `/show/${show.id}/comment?sid=${Cookie.get("sid")}`, true)
				xhr.onreadystatechange = () => {
					if (xhr.readyState === 4) {
						if (xhr.status === 200) {
							let json = JSON.parse(xhr.responseText)
							resolve(json)
						} else {
							reject("Не удалось обновить комментарий.")
						}
					}
				}
				xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8")
				xhr.send(JSON.stringify({
					comment: comment
				}))
			})
		}	

		function completeShow(show) {
			return new Promise((resolve, reject) => {
				let xhr = new XMLHttpRequest()
				xhr.open("PUT", config.restApiHost + `/show/${show.id}/complete/${show.completed === "1" ? "0" : "1" }?sid=${Cookie.get("sid")}`, true)
				xhr.onreadystatechange = ()=>{
					if (xhr.readyState === 4) {
						if (xhr.status === 200) {
							let json = JSON.parse(xhr.responseText)
							resolve(json)
						} else {
							reject("Не удалось завершить шоу.")
						}
					}
				}
				xhr.send()
			})
		}
		
		this.setState({
			dialog: <CompleteShowDialog
				show = {show}
				onCompleteShow = {(show, comment) => {
					updateShowComment(show, comment).then(show => {
						completeShow(show).then(show => {
							this.setState({
								dialog: undefined,
							}, this.update)
						}, this.handle_error)
					}, this.handle_error)
				}}
				onCancel = {() => this.setState({dialog: undefined})}
			/>
		})
	}

	handle_ControlPanel_onSaveClick = () => {
		this.setState({dialog: <SaveShowDialog 
			shows = {this.state.shows}
			onSaveClick = {(shows) => {

				let rows = ["№ КОРОБКИ, ВЕДУЩИЙ, ШОУ, АДРЕС"]

				for (let show of shows) {
					let box = String(show.boxBig).replace(/"/g, '""')
					let artists = show.artists.map(a => a.name).join(", ").replace(/"/g, '""')
					let name = show.name.replace(/"/g, '""')
					let address = show.address.replace(/"/g, '""')
					rows.push(`"${box}","${artists}","${name}","${address}"`)
				}

				let content = rows.join("\n")

				// Сохранение в .csv Файл
				let date = new Date()
				const link = document.createElement("a")
				const file = new Blob([content], {type: "text/plain"})
				link.href = URL.createObjectURL(file)
				link.download = `список шоу ${String(date.getDate()).padStart(2, "0")}-${String(date.getMonth()+1).padStart(2, "0")}-${date.getFullYear()}.csv`
				link.click()
				URL.revokeObjectURL(link.href)

				this.setState({dialog: undefined})
			}}
			onCancelClick = {() => this.setState({dialog: undefined})}
		/>})
	}

	render() {

		if (this.state.screen) {
			return this.state.screen
		}

		return <Screen
			onClick = {e => {
				e.stopPropagation()
				if (!this.state.dialog) {
					this.setState({
						selected: undefined
					})
				}
			}}
		>

			{this.state.dialog}

			<ControlPanel
				shows = {this.state.shows}
				selected = {this.state.selected}
				filters = {this.filters}
				filter = {this.state.filter}
				orderByDateConditions = {this.orderByDateConditions}
				orderByDate = {this.state.orderByDate}
				onCreateShowClick = {this.handleCreateShow}
				onOpenShowClick = {this.handleOpenShow}
				onEditShowClick = {this.handleEditShow}
				onDeleteShowClick = {this.handleDeleteShow}
				onSelectFilter = {this.handleSelectFilter}
				onSelectOrderByDate = {this.handleSelectOrderByDate}
				onSaveClick = {this.handle_ControlPanel_onSaveClick}
			/>

			<SearchPanel
				onChange = {this.handleSearch}
			/>

			<ShowsList
				shows = {this.state.shows}
				selected = {this.state.selected}
				onClickShow = {this.handleClickShow}
				onCloseShow = {this.handleCompleteShow}
			/>

		</Screen>

	}

}

export default ShowsScreen
